import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '../i18n';

const LanguageSwitcher = ({ className = '', variant = 'default' }) => {
  const [currentLang, setCurrentLang] = useState(i18n.language || 'fr');
  const location = useLocation();
  const navigate = useNavigate();
  
  // Écouter les changements de langue
  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLang(i18n.language || 'fr');
    };

    // Écouter les changements de langue i18n
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const toggleLanguage = (lang) => {
    try {
      // Sauvegarder la position de scroll actuelle
      const currentScrollY = window.scrollY;
      
      // Changer la langue
      i18n.changeLanguage(lang);
      
      // Sauvegarder en localStorage
      localStorage.setItem('i18nextLng', lang);
      
      // Mettre à jour l'URL sans déclencher de scroll
      const currentPath = location.pathname;
      const newPath = currentPath.replace(/^\/(fr|en)/, `/${lang}`);
      navigate(newPath, { replace: true, state: { preserveScroll: true } });
      
      // Émettre un événement personnalisé pour notifier les autres composants
      window.dispatchEvent(new CustomEvent('languageChanged'));
      
      // Restaurer la position de scroll après un court délai
      setTimeout(() => {
        window.scrollTo({
          top: currentScrollY,
          left: 0,
          behavior: 'instant' // Utiliser 'instant' pour éviter l'animation
        });
      }, 50);
      
    } catch (error) {
      console.error('Erreur lors du changement de langue:', error);
    }
  };

  if (variant === 'compact') {
    return (
      <div className={`flex items-center space-x-1 bg-gray-50/95 rounded-full px-3 py-1 backdrop-blur-sm ${className}`}>
        <Globe className="h-3 w-3 text-[#089556]" />
        <button 
          onClick={() => toggleLanguage('fr')} 
          className={`px-2 py-1 text-xs font-medium rounded-full transition-colors duration-200 ${
            currentLang === 'fr' 
              ? 'bg-[#089556] text-white shadow-md' 
              : 'text-gray-600 hover:text-[#089556] hover:bg-gray-100'
          }`}
        >
          FR
        </button>
        <button 
          onClick={() => toggleLanguage('en')} 
          className={`px-2 py-1 text-xs font-medium rounded-full transition-colors duration-200 ${
            currentLang === 'en' 
              ? 'bg-[#089556] text-white shadow-md' 
              : 'text-gray-600 hover:text-[#089556] hover:bg-gray-100'
          }`}
        >
          EN
        </button>
      </div>
    );
  }

  // Variant par défaut
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <Globe className="h-4 w-4 text-[#089556]" />
      <button 
        onClick={() => toggleLanguage('fr')} 
        className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${
          currentLang === 'fr' 
            ? 'bg-[#089556] text-white shadow-lg' 
            : 'text-gray-700 hover:text-[#089556] hover:bg-gray-100'
        }`}
      >
        Français
      </button>
      <button 
        onClick={() => toggleLanguage('en')} 
        className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${
          currentLang === 'en' 
            ? 'bg-[#089556] text-white shadow-lg' 
            : 'text-gray-700 hover:text-[#089556] hover:bg-gray-100'
        }`}
      >
        English
      </button>
    </div>
  );
};

export default LanguageSwitcher;
